<template>
  <div class="content">
    <div class="container-fluid">
       <div class="row">
        <b-modal
            id="modal-top-add"
            hide-footer
            title="Add Users"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add Users</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitAddForm)"
              >
                <b-row no-gutters>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.firstName"
                      @update:modelValue="
                        (newValue) => (addData.firstName = newValue)
                      "
                      :rules="{ required: true, min: 3 , max: 20, regex:/^[a-zA-Z]+$/}"
                      id="text-firstName"
                      name="text-firstName"
                      label="First Name"
                      class="mb-1 mr-sm-2"
                      description="text-firstName-feedback"
                      validatorName="First Name"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.lastName"
                      @update:modelValue="
                        (newValue) => (addData.lastName = newValue)
                      "
                      :rules="{ required: true, min: 3 , max: 20, regex:/^[a-zA-Z]+$/ }"
                      id="text-lastName"
                      name="text-lastName"
                      label="Last Name"
                      class="mb-1 mr-sm-2"
                      description="text-lastName-feedback"
                      validatorName="Last Name"
                    />
                  </b-col>
                  <b-col md="12" style="justify-content: center; align-items: center">
  <Vinput
    inputType="text"
    :modelValue="addData.username"
    @update:modelValue="(newValue) => {
      // Check for special characters, spaces, and update the model value
      const sanitizedValue = newValue.replace(/[^a-zA-Z0-9\s]/g, ''); // Allow spaces
      addData.username = sanitizedValue.slice(0, 15); // Limiting to 15 characters
    }"
    :rules="{ required: true, min: 3, max: 15 }"
    id="text-userName"
    name="text-userName"
    label="Username"
    class="mb-1 mr-sm-2"
    description="text-userName-feedback"
    validatorName="Username"
  />
</b-col>

                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputGroup
                      inputType="text"
                      :modelValue="addData.phoneNumber"
                      @update:modelValue="
                        (newValue) => (addData.phoneNumber = newValue)
                      "
                      :rules="{ required: true, regex:/^\d{9}$/ }"
                      id="text-phoneNumber"
                      name="text-phoneNumber"
                      label="Phone Number"
                      class="mb-1 mr-sm-2"
                      description="text-phoneNumber-feedback"
                      validatorName="Phone Number"
                      prepend="+251"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.email"
                      @update:modelValue="
                        (newValue) => (addData.email = newValue)
                      "
                      :rules="{ regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/ }"
                      id="text-email"
                      name="text-email"
                      label="Email"
                      class="mb-1 mr-sm-2"
                      description="text-email-feedback"
                      validatorName="Email"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.role"
                      @update:modelValue="
                        (newValue) => (addData.role = newValue)
                      "
                      :options="roleOptions"
                      :rules="{ required: true }"
                      id="text-role"
                      name="text-role"
                      label="Role"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-role-feedback"
                      validatorName="Role"
                    />
                  </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
        </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-EditUsers"
            hide-footer
            title="Edit Users"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Edit Users</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitEditForm)"
              >
              <b-row no-gutters>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedUsers.firstName"
                      @update:modelValue="
                        (newValue) => (selectedUsers.firstName = newValue)
                      "
                      :rules="{ required: true, min: 3, regex:/^[a-zA-Z]+$/}"
                      id="text-firstName"
                      name="text-firstName"
                      label="First Name"
                      class="mb-1 mr-sm-2"
                      description="text-firstName-feedback"
                      validatorName="First Name"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedUsers.lastName"
                      @update:modelValue="
                        (newValue) => (selectedUsers.lastName = newValue)
                      "
                      :rules="{ required: true, min: 3, regex:/^[a-zA-Z]+$/ }"
                      id="text-lastName"
                      name="text-lastName"
                      label="Last Name"
                      class="mb-1 mr-sm-2"
                      description="text-lastName-feedback"
                      validatorName="Last Name"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedUsers.username"  
                      @update:modelValue="
                        (newValue) => (selectedUsers.username = newValue)
                      "
                      :rules="{ required: true, min: 3 }"
                      id="text-userName"
                      name="text-userName"
                      label="Username"
                      class="mb-1 mr-sm-2"
                      description="text-userName-feedback"
                      validatorName="Username"
                      disabled="disabled"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputGroup
                      inputType="text"
                      :modelValue="selectedUsers.phoneNumber"
                      @update:modelValue="
                        (newValue) => (selectedUsers.phoneNumber = newValue)
                      "
                      :rules="{ required: true, regex:/^\d{9}$/ }"
                      id="text-phoneNumber"
                      name="text-phoneNumber"
                      label="Phone Number"
                      class="mb-1 mr-sm-2"
                      description="text-phoneNumber-feedback"
                      validatorName="Phone Number"
                      prepend="+251"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedUsers.email"
                      @update:modelValue="
                        (newValue) => (selectedUsers.email = newValue)
                      "
                      :rules="{ regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/ }"
                      id="text-email"
                      name="text-email"
                      label="Email"
                      class="mb-1 mr-sm-2"
                      description="text-email-feedback"
                      validatorName="Email"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedUsers.role"
                      @update:modelValue="
                        (newValue) => (selectedUsers.role = newValue)
                      "
                      :options="roleOptions"
                      :rules="{ required: true }"
                      id="text-role"
                      name="text-role"
                      label="Role"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-role-feedback"
                      validatorName="Role"
                    />
                  </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
       <div class="row">
        <b-modal
            id="modal-top-EditUsersPermission"
            hide-footer
            title="Edit Users Permission"
            content-class="shadow" 
            size="lg"
          >
            <template #modal-header="{ close }">
              <h5>Edit Users Permission</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <b-row>
            <b-col lg="8" class="my-1">
                <b-button v-if="modulePermission.update == 1" @click="AddPermission(ID)" class="btn-outline-primary">
                  <b-icon class="text-center" icon="plus"></b-icon> Add Module
                </b-button>
              </b-col>

            </b-row>
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 395px;"
              striped
              responsive="md"
              hover
            >
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>Module</b-th>
                  <b-th>View</b-th>
                  <b-th>Create</b-th>
                  <b-th>Update</b-th>
                  <b-th>Delete</b-th>
                  <b-th sticky-column style="height: 45px;"></b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <template>
                <b-tr
                  v-for="(item, index) in modulePermissionList"
                  :key="item.ID"
                >
                    <b-td>{{++index}}</b-td>
                    <b-td>{{item.name}}</b-td>
                    <b-td v-if="item.listData == 1"><b-icon icon="check-lg" style="color: rgb(37, 91, 48)"></b-icon></b-td>
                    <b-td v-else><b-icon icon="x-lg" style="color: rgb(251, 64, 75)"></b-icon></b-td>
                    <b-td v-if="item.createData == 1"><b-icon icon="check-lg" style="color: rgb(37, 91, 48)"></b-icon></b-td>
                    <b-td v-else><b-icon icon="x-lg" style="color: rgb(251, 64, 75)"></b-icon></b-td>
                    <b-td v-if="item.updateData == 1"><b-icon icon="check-lg" style="color: rgb(37, 91, 48)"></b-icon></b-td>
                    <b-td v-else><b-icon icon="x-lg" style="color: rgb(251, 64, 75)"></b-icon></b-td>
                    <b-td v-if="item.deleteData == 1"><b-icon icon="check-lg" style="color: rgb(37, 91, 48)"></b-icon></b-td>
                    <b-td v-else><b-icon icon="x-lg" style="color: rgb(251, 64, 75)"></b-icon></b-td>
                    <b-td sticky-column>
                      <b-row style="width: 180px;">
                        <b-col md="6" class="mb-2" v-if="modulePermission.update == 1">
                          <b-badge @click="EditPermission(item.name)" variant="primary">Edit</b-badge>
                        </b-col>
                        <b-col md="6" class="mb-2" v-if="modulePermission.update == 1">
                          <b-badge @click="DeletePermission(item.name)" variant="primary">Delete</b-badge>
                        </b-col>
                      </b-row>
                    </b-td>
                </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-add-permission"
            hide-footer
            title="Add Permission"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add Permission</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitAddPermissionForm)"
              >
                <b-row no-gutters>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addPermission.moduleName"
                      @update:modelValue="
                        (newValue) => (addPermission.moduleName = newValue)
                      "
                      :options="moduleOptions"
                      :rules="{ required: true }"
                      id="text-module"
                      name="text-module"
                      label="Module"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-module-feedback"
                      validatorName="Module"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <b-form-checkbox v-model="addPermission.listData" name="check-button" switch>
                          View
                      </b-form-checkbox>
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <b-form-checkbox v-model="addPermission.createData" name="check-button" switch>
                          Create
                      </b-form-checkbox>
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <b-form-checkbox v-model="addPermission.updateData" name="check-button" switch>
                          Update
                      </b-form-checkbox>
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <b-form-checkbox v-model="addPermission.deleteData" name="check-button" switch>
                          Delete
                      </b-form-checkbox>
                  </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
        </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-edit-permission"
            hide-footer
            title="Edit Permission"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Edit Permission</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitEditPermissionForm)"
              >
                <b-row no-gutters>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vinput
                      :modelValue="addPermission.moduleName"
                      @update:modelValue="
                        (newValue) => (addPermission.moduleName = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-module"
                      name="text-module"
                      label="Module"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-module-feedback"
                      validatorName="Module"
                      disabled="disabled"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <b-form-checkbox v-model="addPermission.listData" name="check-button" switch>
                          View
                      </b-form-checkbox>
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <b-form-checkbox v-model="addPermission.createData" name="check-button" switch>
                          Create
                      </b-form-checkbox>
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <b-form-checkbox v-model="addPermission.updateData" name="check-button" switch>
                          Update
                      </b-form-checkbox>
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <b-form-checkbox v-model="addPermission.deleteData" name="check-button" switch>
                          Delete
                      </b-form-checkbox>
                  </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
        </b-modal>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
             <template slot="header">
              <b-row>
              <b-col lg="8" class="my-1">
                <b-button v-if="modulePermission.create == 1" @click="AddUsers()" class="btn-outline-primary">
                  <b-icon class="text-center" icon="plus"></b-icon> New Users
                </b-button>
              </b-col>
             <b-col lg="4" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Filter"
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 395px;"
              striped
              responsive="sm"
              hover
            >
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>First Name</b-th>
                  <b-th>Last Name</b-th>
                  <b-th>User Name</b-th>
                  <b-th>Email</b-th>
                  <b-th>Phone Number</b-th>
                  <b-th>Role</b-th>
                  <b-th>Created At</b-th>
                  <b-th sticky-column style="height: 45px;"></b-th>
                </b-tr>
              </b-thead>
              <template v-if="spinner">
                <b-tbody class="text-center">
                   <b-tr >
                       <b-td colspan="9" class="text-center" style="display: table-cell">
                        <b-spinner
                        style="height: 3rem; width: 3rem;"
                          variant="warning"
                        ></b-spinner>
                       </b-td>
                    </b-tr>
                </b-tbody>
              </template>
              <template v-else>
              <b-tbody>
                <template v-if="filterTable.length === 0">
                    <b-tr>
                      <b-td colspan="8" class="text-center">Nothing found</b-td>
                      <b-td></b-td>
                    </b-tr>
                </template>
                <template v-else>
                <b-tr
                  v-for="(item, index) in filterTable"
                  :key="item.ID"
                >
                    <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                    <b-td>{{item.firstName}}</b-td>
                    <b-td>{{item.lastName}}</b-td>
                    <b-td>{{item.username}}</b-td>
                    <b-td>{{item.email}}</b-td>
                    <b-td>{{item.phoneNumber}}</b-td>
                    <b-td>{{item.role.name}}</b-td>
                    <b-td>{{item.createdDate}}</b-td>
                    <b-td sticky-column>
                      <b-row>
                          <b-col md="4" class="mb-2" v-if="modulePermission.update == 1 && item.lockStatus == 1">
                            <b-icon icon="unlock-fill" class="btn-icon" title="Lock User" @click="LockUser(item.username)" aria-hidden="true" ></b-icon>
                          </b-col>
                        <b-col md="4" class="mb-2" v-if="modulePermission.update == 1 && item.lockStatus == 0">
                          <b-icon icon="Lock-fill" class="btn-icon" title="UnLock User" @click="UnlockUser(item.username)" aria-hidden="true" ></b-icon>
                        </b-col>
                       <b-col md="4" class="mb-2" v-if="modulePermission.update == 1">
                          <b-icon icon="pencil-square" class="btn-icon" title="Edit User" @click="EditUsers(item.id)" aria-hidden="true" ></b-icon>
                        </b-col>
                        <b-col md="4" class="mb-2" v-if="modulePermission.update == 1">
                          <b-icon icon="person-lines-fill" class="btn-icon" title="Users Permission" @click="ViewPermission(item.id)" aria-hidden="true" ></b-icon>
                        </b-col>
                      </b-row>
                    </b-td>
                </b-tr>
                </template>
              </b-tbody>
              </template>
            </b-table-simple>
            <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                   <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
            </b-row>
           </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import Vinput from 'src/components/Inputs/Vinput.vue'
  import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
  import Vselect from 'src/components/Inputs/Vselect.vue'
  import VinputGroup from 'src/components/Inputs/VinputGroup.vue'
  export default {
    components: {
      LTable,
      Card,
      Vinput,
      VinputNumber,
      Vselect,
      VinputGroup
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        perPage: 7,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        items: [],
        addData: {
            firstName: "",
            lastName : "",
            accountNumber: "",
            email: "",
            username: "",
            phoneNumber: "",
            role: "",
            createdBy: sessionStorage.getItem("ID"),
            ownedBy: sessionStorage.getItem("ID")
        },
        addPermission:{
          moduleName:"",
          listData: true,
          createData: false,
          updateData: false,
          deleteData: false,
        },
        selectedUsers: {},
        roleOptions:[
          {value: "MANAGER", text:"Manager"},
          {value: "FINANCE_MANAGER", text:"Finance Manager"},
          {value: "MAKER", text:"Maker"},
        ],
        moduleOptions: [],
        filter: "",
        modulePermissionList: [],
        currentUserModules: [],
        spinner: true
      }
    },
     mounted() {
      this.getModules();
      this.getModulesList();
      this.getUsersByOwnerID();
      this.$on("AfterComplete", () => {
        this.getModules();
        this.getModulesList();
        this.getUsersByOwnerID();
      });
    },
    computed: {
      filterTable() {
        var searchItems = this.items;
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          if (item.username.toLowerCase().indexOf(searchString) !== -1 ||  item.firstName.toLowerCase().indexOf(searchString) !== -1 || item.lastName.toLowerCase().indexOf(searchString) !== -1 || item.phoneNumber.toLowerCase().indexOf(searchString) !== -1 ) {
            return item;
          }
        });
        return searchItems;
      },
    },
    methods: {
    restrictCharacters(event) {
    const allowedCharacters = /^[a-zA-Z0-9]+$/;
    if (!event.key.match(allowedCharacters) && event.key !== ' ') {
     event.preventDefault();
    }
  },
      nameValidation(value){
        const regex = /^[a-zA-Z]+$/;
        return regex.text(value) || 'Only letters are allowed';
      },
      validateUsername(value) {
      const restrictedChars = ["'", '"', ';', '%', '(', ')', '*', '-', '-', '=', '$', ' ', '/'];
      
      for (let i = 0; i < restrictedChars.length; i++) {
        if (value.includes(restrictedChars[i])) {
          return 'Invalid character found in the username';
        }
      }
      
      return true;
    },
      getModulesList(){
         this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              Array.from(response.data.modules).forEach((value) => {
                this.moduleOptions.push({
                  value: value.name,
                  text: value.name
                });
              });
          })
          .catch(error=>{
              console.log(error);
          })
      },
      getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              //this.items = response.data;
              var modulesList = response.data.modules;
              var UserModule = modulesList.filter(x=>x.name === "Accounts");
              //console.log("UserModukleList", UserModule);
              if(UserModule !== null){
                this.modulePermission.view = UserModule[0].listData;
                this.modulePermission.create = UserModule[0].createData;
                this.modulePermission.update = UserModule[0].updateData;
                this.modulePermission.delete = UserModule[0].deleteData;
              }
          })
          .catch(error=>{
              console.log(error);
          })
      },
      numberWithCommas(x) {
        if(x !== null && x !== undefined){
            x = x.toFixed(2);
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      },
      getUsersByOwnerID(){
        this.spinner = true;
          this.$store.dispatch('getUsersByOwnerID', {userId:  parseInt( sessionStorage.getItem("ID")), currentId:  parseInt( sessionStorage.getItem("userID")), page: this.currentPage, line: this.perPage})
          .then(response=>{
            //console.log("sdkfh", response.data);
              this.items = response.data.Contents.filter(x=>x.id != sessionStorage.getItem("userID"));
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      changePage(event, page){
        this.spinner = true;
        this.$store.dispatch('getUsersByOwnerID',{userId:  parseInt( sessionStorage.getItem("ID")), currentId:  parseInt( sessionStorage.getItem("userID")), page: page, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents.filter(x=>x.id != sessionStorage.getItem("userID"));
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      changePerPage(event){
        this.spinner = true;
        this.$store.dispatch('getUsersByOwnerID', {userId:  parseInt( sessionStorage.getItem("ID")), currentId:  parseInt( sessionStorage.getItem("userID")), page: this.currentPage, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents.filter(x=>x.id != sessionStorage.getItem("userID"));
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      AddUsers(){
        this.$bvModal.show('modal-top-add');
      },
      submitAddForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              this.$store.dispatch('AddUsersForCollectors', {
                firstName: this.addData.firstName,
                lastName : this.addData.lastName,
                accountNumber: this.addData.accountNumber,
                email: this.addData.email,
                username: this.addData.username,
                phoneNumber: "+251"+this.addData.phoneNumber,
                role: this.addData.role,
                createdBy: sessionStorage.getItem("ID"),
                ownedBy: this.addData.ownedBy
              })
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `Users successfully created.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    }
                  )
                    this.$bvModal.hide('modal-top-add');
                    this.clearData();
              })
              .catch(error=>{
                  this.$notifications.notify(
                  {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      EditUsers(ID){
        this.selectedUsers = this.items.filter(item=> item.id == ID)[0];
        this.selectedUsers.role = this.selectedUsers.role.name;
        if(this.selectedUsers.phoneNumber.startsWith("+251")){
          var some = this.selectedUsers.phoneNumber.slice(4,13);
          this.selectedUsers.phoneNumber = some;
        } 
        if(this.selectedUsers.phoneNumber.startsWith("09")){
          var some = this.selectedUsers.phoneNumber.slice(2,9);
          this.selectedUsers.phoneNumber = some;
        }
        this.$bvModal.show('modal-top-EditUsers');
      },
      submitEditForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {
            if(value === true){
              this.$store.dispatch('UpdateUserCollector', {
                id: this.selectedUsers.id,
                firstName: this.selectedUsers.firstName,
                lastName : this.selectedUsers.lastName,
                accountNumber: this.selectedUsers.accountNumber,
                email: this.selectedUsers.email,
                phoneNumber: "+251"+this.selectedUsers.phoneNumber,
                role: this.selectedUsers.role
              })
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `The Users Successfully Updated.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-EditUsers');
                    this.clearData();
              })
              .catch(error=>{
                console.log(error);
                this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      ViewPermission(ID){
        this.$store.dispatch('getModulesPermission', {userId: ID})
        .then(response=>{
          this.selectedUsers = this.items.filter(item=> item.id == ID)[0];
          this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(currentUserResponse=>{
            var currentUserModules = currentUserResponse.data.modules.map(m => m.name);
            this.modulePermissionList = response.data.modules.filter(m => currentUserModules.includes(m.name));
            this.$bvModal.show('modal-top-EditUsersPermission');
          })
          .catch(error=>{
            console.log(error);
          })
        })
        .catch(error=>{
          console.log(error);
        })
      },
      AddPermission(ID){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
        .then(response=>{
          this.currentUserModules = response.data.modules;
          this.$bvModal.show('modal-top-add-permission');
        })
        .catch(error=>{
          console.log(error);
        })
      },
      submitAddPermissionForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              var currentUserModule = this.currentUserModules.find(m => m.name === this.addPermission.moduleName);
              var moduleToAdd  = {
                userId: this.selectedUsers.id,
                module: this.addPermission.moduleName,
                createData: (this.addPermission.createData && currentUserModule.createData) ? 1:0,
                listData: (this.addPermission.listData && currentUserModule.listData) ? 1:0,
                updateData: (this.addPermission.updateData && currentUserModule.updateData) ? 1:0,
                deleteData: (this.addPermission.deleteData && currentUserModule.deleteData) ? 1:0
              }

              this.$store.dispatch('AddModuleAndPermission', moduleToAdd)
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `Module and Permission Successfully created.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    }
                  )
                 this.$store.dispatch('getModulesPermission', {userId: this.selectedUsers.id})
                  .then(response=>{
                    this.$store.dispatch('getModulesPermission', {userId: this.selectedUsers.id})
                    .then(currentUserResponse=>{
                      var currentUserModules = currentUserResponse.data.modules.map(m => m.name);
                      this.modulePermissionList = response.data.modules.filter(m => currentUserModules.includes(m.name));
                    })
                    .catch(error=>{
                      console.log(error);
                    })
                  })
                  .catch(error=>{
                    console.log(error);
                  })
                  this.$bvModal.hide('modal-top-add-permission');
                  this.clearData();
              })
              .catch(error=>{
                   this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      EditPermission(name){
        var moduleToEdit = this.modulePermissionList.filter(item=>item.name == name)[0];
        this.addPermission.moduleName = moduleToEdit.name;
        this.addPermission.createData = moduleToEdit.createData == 1? true: false;
        this.addPermission.listData = moduleToEdit.listData == 1? true: false;
        this.addPermission.deleteData = moduleToEdit.deleteData == 1? true: false;
        this.addPermission.updateData = moduleToEdit.updateData == 1? true: false;
        this.$bvModal.show('modal-top-edit-permission');
      },
      submitEditPermissionForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              var moduleToEdit  = {
                userId: this.selectedUsers.id,
                module: this.addPermission.moduleName,
                createData: this.addPermission.createData == true ? 1:0,
                listData: this.addPermission.listData == true ? 1:0,
                updateData: this.addPermission.updateData == true ? 1:0,
                deleteData: this.addPermission.deleteData == true ? 1:0
              }

              this.$store.dispatch('UpdateModuleAndPermission', moduleToEdit)
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `Module and Permission Successfully updated.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    }
                  )
                 this.$store.dispatch('getModulesPermission', {userId: this.selectedUsers.id})
                  .then(response=>{
                    this.$store.dispatch('getModulesPermission', {userId: this.selectedUsers.id})
                    .then(currentUserResponse=>{
                      var currentUserModules = currentUserResponse.data.modules.map(m => m.name);
                      this.modulePermissionList = response.data.modules.filter(m => currentUserModules.includes(m.name));
                    })
                    .catch(error=>{
                      console.log(error);
                    })
                  })
                  .catch(error=>{
                    console.log(error);
                  })
                  this.$bvModal.hide('modal-top-edit-permission');
                  this.clearData();
              })
              .catch(error=>{
                this.$notifications.notify(
                {
                  message: error.response.data,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      DeletePermission( moduleName){
          this.$bvModal.msgBoxConfirm('Are you sure you want to delete this module?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              this.$store.dispatch('DeleteModuleandPermissionForUser', {userId: this.selectedUsers.id, module: moduleName})
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `Module deleted successfully from the user.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    }
                  )
                  this.modulePermissionList = this.modulePermissionList.filter(x=>x.name != moduleName);
              })
              .catch(error=>{
                  console.log(error);
              })
            }
        })
        .catch(error=>{
          this.$notifications.notify(
          {
            message: error.response.data,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          })
          console.log(error)
        })
      },
      LockUser(username){
        this.$bvModal.msgBoxConfirm('Are you sure you want to lock this user?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              this.$store.dispatch('LockUser', {userName: username})
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `User locked successfully.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    }
                  )
                  this.clearData();
              })
              .catch(error=>{
                  console.log(error);
                  this.$notifications.notify(
                  {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
              })
            }
        })
        .catch(error=>{
            console.log(error);
        })
      },
      UnlockUser(username){
        this.$bvModal.msgBoxConfirm('Are you sure you want to unlock this user?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              this.$store.dispatch('UnlockUser', {userName: username})
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `User unlocked successfully.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    }
                  )
                  this.clearData();
              })
              .catch(error=>{
                console.log(error);
                this.$notifications.notify(
                {
                  message: error.response.data,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              })
            }
        })
        .catch(error=>{
            console.log(error);
        })
      },
      getCurrentModulePermission(permissionType) {
        if (!this.addPermission.moduleName || !this.currentUserModules.length) return false;
        var currentModule = this.currentUserModules.find(m => m.name === this.addPermission.moduleName);
        return currentModule ? currentModule[permissionType] === 1 : false;
      },
      clearData(){
        this.moduleOptions = [];
        this.addData.username = this.addData.firstName = this.addData.lastName = this.addData.email = this.addData.phoneNumber = this.addData.role = "";
        this.$emit('AfterComplete');
      }
    }
  }
</script>
<style scoped>
  .b-table-sticky-column:last-child {
    right: 0;
  }
  .text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
  }
  .btn-icon{
  font-size: 27px !important;
  padding: 3px 5px 3px 5px;
  width: 40px;
  color:  rgb(37, 91, 48);
  border: 2px solid rgb(37, 91, 48);
}
.btn-icon:hover,
.btn-icon:focus {
  cursor: pointer;
  background-color: rgb(37, 91, 48) !important;
  color: rgba(240, 206, 13, 0.937) !important;
  border-radius: 4px;
  transition: .4s;
}
</style>